import {Component, OnInit} from "@angular/core";
import {New} from "./new";
import {NewService} from "./new.service";
import {Router} from "@angular/router";
declare var jquery:any; // 這邊用 var 
declare let $:any; // 當然 let 也可以
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container">
        <div class="title-clothes">
        <div class="title-clothes-line"></div>最新消息<div class="title-clothes-line2"></div>
        </div>
        
        <div class="categoryBtn">
        <button class="newBtn2" (click)="gotoNew()">全部</button>
        <button class="newBtn2" (click)="gotoNew2()">活動</button>
        <button class="newBtn2" (click)="gotoNew3()">評測</button>
        <button class="newBtn2" (click)="gotoNew4()">新品</button>
        <button class="newBtn2" (click)="gotoNew5()">重要</button>
        <button class="newBtn2" (click)="gotoNew6()">情報</button>
        </div>
        <div class="cool"><button class="changefont" (click)="gotoDetail220()">2020-08-09<span class="category">情報</span><p class="cool2"></p>2020 桌球器材流行新趨勢 - 黏性內能膠皮💥💥</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail196()">2020-02-19<span class="category">情報</span><p class="cool2"></p>『波爾桌球』贊助選手"張佑安",勇奪國際公開賽金牌</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail194()">2020-01-20<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY" What is Dignics 09C?</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail193()">2020-01-19<span class="category">情報</span><p class="cool2"></p>新北捷運環狀線今天 (1/19) 開放試乘囉！💯💯💯</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail192()">2020-01-13<span class="category">情報</span><p class="cool2"></p>瑞典"STIGA"執行長Mr. Ola Werner 蒞臨考察</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail191()">2020-01-07<span class="category">情報</span><p class="cool2"></p>2020 "MIZUNO"簽下長崎美柚 Nagasaki Miyuu </button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail190()">2020-01-01<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY"宣佈簽下前球王『奧洽洛夫』</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail188()">2019-12-13<span class="category">情報</span><p class="cool2"></p>賀！波爾代表『尤思宏』勇奪年終單打菁英賽冠軍🏆</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail187()">2019-12-12<span class="category">情報</span><p class="cool2"></p>『陳思羽』首場加油見面會在波爾桌球 敬請期待！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail183()">2019-11-15<span class="category">情報</span><p class="cool2"></p>"波爾桌球"2020年度代言人 - 國手♡劉昱昕♡</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail173()">2019-09-02<span class="category">情報</span><p class="cool2"></p>Ezvid Wiki《2019年度十大桌球拍》</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail168()">2019-07-21<span class="category">情報</span><p class="cool2"></p>賀！T2 Diamond Malaysia男單冠軍-林昀儒</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail162()">2019-06-08<span class="category">情報</span><p class="cool2"></p>延續氣勢再奪2019香港公開賽混雙冠軍！🏆🏆</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail161()">2019-06-01<span class="category">情報</span><p class="cool2"></p>賀！"林昀儒／鄭怡靜" 中國公開賽勇奪混雙冠軍🏆</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail159()">2019-05-26<span class="category">情報</span><p class="cool2"></p>賀！波爾贊助球員「尤思宏」泛美運動會資格賽第一</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail157()">2019-05-18<span class="category">情報</span><p class="cool2"></p>2019年4月份全日本桌球底板與膠皮銷售排行榜</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail156()">2019-05-17<span class="category">情報</span><p class="cool2"></p>賀！波爾桌球贊助選手「張佑安」當選國手(15歲組)</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail155()">2019-05-15<span class="category">情報</span><p class="cool2"></p>"Made in Taiwan" - ARIEX艾銳斯桌球品牌</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail152()">2019-05-03<span class="category">情報</span><p class="cool2"></p>典藏"BUTTERFLT"🇯🇵福原愛ZLF🇹🇼最後機會</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail150()">2019-04-28<span class="category">情報</span><p class="cool2"></p>2019 布達佩斯世錦賽 🏆男單金牌 - 馬龍🏆</button><br><br></div> 

        <button class="newBtn" (click)="show1()" *ngIf="more1 == false">更多消息</button>

        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail149()">2019-04-28<span class="category">情報</span><p class="cool2"></p>2019 布達佩斯世錦賽 🏆女單金牌 - 劉詩雯🏆</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail146()">2019-04-07<span class="category">情報</span><p class="cool2"></p>"坂本龍介"將參與日本MIZUNO桌球產品營銷及開發</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail139()">2019-03-05<span class="category">情報</span><p class="cool2"></p>即日起"BUTTERFLY" Viscaria FL/ST 建議售價調漲</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail137()">2019-02-22<span class="category">情報</span><p class="cool2"></p>2019 "BUTTERFLY" VISCARIA ST 復刻再現👍👍👍</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail126()">2019-01-21<span class="category">情報</span><p class="cool2"></p>「大島祐哉」榮獲全日本卓球錦標賽 男單亞軍🥈</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail121()">2019-01-03<span class="category">情報</span><p class="cool2"></p>韓國品牌XIOM與Hugo Calderano 簽約</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail120()">2018-12-28<span class="category">情報</span><p class="cool2"></p>「桌球勵志哥」葉致緯的故事...</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail115()">2018-12-06<span class="category">情報</span><p class="cool2"></p>韓國"XIOM" 2019年新拍即將上市</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail114()">2018-12-05<span class="category">情報</span><p class="cool2"></p>BUTTERFLY "張本智和"底板 呼之欲出😎</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail188()">2019-12-13<span class="category">情報</span><p class="cool2"></p>賀！波爾代表『尤思宏』勇奪年終單打菁英賽冠軍🏆</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail187()">2019-12-12<span class="category">情報</span><p class="cool2"></p>『陳思羽』首場加油見面會在波爾桌球 敬請期待！</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail110()">2018-11-24<span class="category">情報</span><p class="cool2"></p>蝴蝶牌 "BUTTERFLY" 新總部落成典禮</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail107()">2018-11-14<span class="category">情報</span><p class="cool2"></p>謎一樣的"BUTTERFLY" Dignics系列</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail106()">2018-11-10<span class="category">情報</span><p class="cool2"></p>"XIOM" 無機膠水不貼在膠皮上❓❓❓</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail101()">2018-10-16<span class="category">情報</span><p class="cool2"></p>"STIGA" 許昕的神祕武器👀 👀 👀</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail98()">2018-09-21<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY"正式簽約中國選手★林高遠★</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail96()">2018-09-14<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY"新產品 11月即將推出～</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail81()">2018-08-07<span class="category">情報</span><p class="cool2"></p>BUTTERFLY蝴蝶牌「朱世赫」削球底板正式停產</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail78()">2018-07-25<span class="category">情報</span><p class="cool2"></p>"ITC"(最新韓國桌球品牌)之新嘗試新體驗</button><br><br></div>
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail61()">2018-05-11<span class="category">情報</span><p class="cool2"></p>感謝台灣美津濃公司總經理 周宏津先生 蒞臨指導</button><br><br></div>

        <button class="newBtn" (click)="show2()" *ngIf="more1==true && more2 == false">更多消息</button>

        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail60()">2018-05-07<span class="category">情報</span><p class="cool2"></p>波爾桌球贊助球員 "王元佑" 勇奪大專校友盃 季軍</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail58()">2018-04-29<span class="category">情報</span><p class="cool2"></p>🎊賀🎊 波爾桌球隊勇奪107年度大同區主委盃 亞軍</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail46()">2018-03-21<span class="category">情報</span><p class="cool2"></p>日本"BUTTERFLY"2018 春夏產品型錄搶先看！</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail45()">2018-03-20<span class="category">情報</span><p class="cool2"></p>“Nittaku” 檜木系列漲價公告</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail43()">2018-03-16<span class="category">情報</span><p class="cool2"></p>好消息📣📣📣 "STIGA" 桌球底板 大降價!!</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail39()">2018-03-03<span class="category">情報</span><p class="cool2"></p>賀★波爾桌球★成為"美津濃MIZUNO"簽約經銷商</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail38()">2018-02-10<span class="category">情報</span><p class="cool2"></p>波爾桌球「台北萬隆體驗站」即將開幕</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail28()">2017-12-18<span class="category">情報</span><p class="cool2"></p>2017國際桌總巡迴賽總決賽冠軍-STIGA之星＊樊振東</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail23()">2017-11-25<span class="category">情報</span><p class="cool2"></p>"ITTF" 國際桌總再次更換比賽用球??!!</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail19()">2017-11-12<span class="category">情報</span><p class="cool2"></p>日本蝴蝶牌”BUTTERFLY”桌球底板的誕生 </button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail16()">2017-10-27<span class="category">情報</span><p class="cool2"></p>⭐"BUTTERFLY 波爾ALC"底板持續熱銷中⭐</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail8()">2017-10-06<span class="category">情報</span><p class="cool2"></p>蝴蝶牌 BUTTERFLY 2017 秋冬新產品目錄發行囉！</button><br><br></div>
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail2()">2017-08-31<span class="category">情報</span><p class="cool2"></p>日本十大暢銷膠皮排行</button><br><br></div>        
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail3()">2017-06-18<span class="category">情報</span><p class="cool2"></p>WTTC 2017 Duesseldorf 充滿樂趣的andro商品展</button><br><br></div>
        <button (click)="topFunction()" id="return-to-top" title="Go to top">Top</button>
       </div>
      
    `,
  providers:[NewService],
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class New6Component implements OnInit{
  constructor(private newservice:NewService,private router:Router){}
  new:New[];
  errorMessage:string;
  public ptitle:string;
  public pcontent:string;
  public more1 : boolean = false 
  public more2 : boolean = false
  ngOnInit(){
    this.getNews();
  }

  select2(title:string,content:string){
    this.newservice.add(title,content);
  }

  getNews(){
    this.newservice.getNews()
      .subscribe(
        products => this.new = products,
        error =>  this.errorMessage = <any>error);


  }
  gotoNew(){
    this.router.navigate(['new']);
  }
  gotoNew2(){
    this.router.navigate(['new2']);
  }
  gotoNew3(){
    this.router.navigate(['new3']);
  }
  gotoNew4(){
    this.router.navigate(['new4']);
  }
  gotoNew5(){
    this.router.navigate(['new5']);
  }
  gotoNew6(){
    this.router.navigate(['new6']);
  }
  gotoNew7(){
    this.router.navigate(['new7']);
  }
  gotoNew8(){
    this.router.navigate(['new8']);
  }
  show1(){
    this.more1 = true
  }
  show2(){
    this.more2 = true
  }
  gotoNewDetail(){
    this.router.navigate(['newdetail']);
  }
  gotoDetail1(){
    this.router.navigate(['detail1']);
  }
  gotoDetail2(){
    this.router.navigate(['detail2']);
  }
  gotoDetail3(){
    this.router.navigate(['detail3']);
  }
  gotoDetail4(){
    this.router.navigate(['detail4']);
  }
  gotoDetail5(){
    this.router.navigate(['detail5']);
  }
  gotoDetail6(){
    this.router.navigate(['detail6']);
  }
  gotoDetail7(){
    this.router.navigate(['detail7']);
  }
  gotoDetail8(){
    this.router.navigate(['detail8']);
  }
  gotoDetail9(){
    this.router.navigate(['detail9']);
  }
  gotoDetail10(){
    this.router.navigate(['detail10']);
  }
  gotoDetail11(){
    this.router.navigate(['detail11']);
  }
  gotoDetail12(){
    this.router.navigate(['detail12']);
  }
  gotoDetail13(){
    this.router.navigate(['detail13']);
  }
  gotoDetail14(){
    this.router.navigate(['detail14']);
  }
  gotoDetail15(){
    this.router.navigate(['detail15']);
  }
  gotoDetail16(){
    this.router.navigate(['detail16']);
  }
  gotoDetail17(){
    this.router.navigate(['detail17']);
  }
  gotoDetail18(){
    this.router.navigate(['detail18']);
  }
  gotoDetail19(){
    this.router.navigate(['detail19']);
  }
  gotoDetail20(){
    this.router.navigate(['detail20']);
  }
  gotoDetail21(){
    this.router.navigate(['detail21']);
  }
  gotoDetail22(){
    this.router.navigate(['detail22']);
  }
  gotoDetail23(){
    this.router.navigate(['detail23']);
  }
  gotoDetail24(){
    this.router.navigate(['detail24']);
  }
  gotoDetail25(){
    this.router.navigate(['detail25']);
  }
  gotoDetail26(){
    this.router.navigate(['detail26']);
  }
  gotoDetail27(){
    this.router.navigate(['detail27']);
  }
  gotoDetail28(){
    this.router.navigate(['detail28']);
  }
  gotoDetail29(){
    this.router.navigate(['detail29']);
  }
  gotoDetail30(){
    this.router.navigate(['detail30']);
  }
  gotoDetail31(){
    this.router.navigate(['detail31']);
  }
  gotoDetail32(){
    this.router.navigate(['detail32']);
  }
  gotoDetail33(){
    this.router.navigate(['detail33']);
  }
  gotoDetail34(){
    this.router.navigate(['detail34']);
  }
  gotoDetail35(){
    this.router.navigate(['detail35']);
  }
  gotoDetail36(){
    this.router.navigate(['detail36']);
  }
  gotoDetail37(){
    this.router.navigate(['detail37']);
  }
  gotoDetail38(){
    this.router.navigate(['detail38']);
  }
  gotoDetail39(){
    this.router.navigate(['detail39']);
  }
  gotoDetail40(){
    this.router.navigate(['detail40']);
  }
  gotoDetail41(){
    this.router.navigate(['detail41']);
  }
  gotoDetail42(){
    this.router.navigate(['detail42']);
  }
  gotoDetail43(){
    this.router.navigate(['detail43']);
  }
  gotoDetail44(){
    this.router.navigate(['detail44']);
  }
  gotoDetail45(){
    this.router.navigate(['detail45']);
  }
  gotoDetail46(){
    this.router.navigate(['detail46']);
  }
  gotoDetail47(){
    this.router.navigate(['detail47']);
  }
  gotoDetail48(){
    this.router.navigate(['detail48']);
  }
  gotoDetail49(){
    this.router.navigate(['detail49']);
  }
  gotoDetail50(){
    this.router.navigate(['detail50']);
  }
  gotoDetail51(){
    this.router.navigate(['detail51']);
  }
  gotoDetail52(){
    this.router.navigate(['detail52']);
  }
  gotoDetail53(){
    this.router.navigate(['detail53']);
  }
  gotoDetail54(){
    this.router.navigate(['detail54']);
  }
  gotoDetail55(){
    this.router.navigate(['detail55']);
  }
  gotoDetail56(){
    this.router.navigate(['detail56']);
  }
  gotoDetail57(){
    this.router.navigate(['detail57']);
  }
  gotoDetail58(){
    this.router.navigate(['detail58']);
  }
  gotoDetail59(){
    this.router.navigate(['detail59']);
  }
  gotoDetail60(){
    this.router.navigate(['detail60']);
  }
  gotoDetail61(){
    this.router.navigate(['detail61']);
  }
  gotoDetail62(){
    this.router.navigate(['detail62']);
  }
  gotoDetail63(){
    this.router.navigate(['detail63']);
  }
  gotoDetail64(){
    this.router.navigate(['detail64']);
  }
  gotoDetail65(){
    this.router.navigate(['detail65']);
  }
  gotoDetail66(){
    this.router.navigate(['detail66']);
  }
  gotoDetail67(){
    this.router.navigate(['detail67']);
  }
  gotoDetail68(){
    this.router.navigate(['detail68']);
  }
  gotoDetail69(){
    this.router.navigate(['detail69']);
  }
  gotoDetail70(){
    this.router.navigate(['detail70']);
  }
  gotoDetail71(){
    this.router.navigate(['detail71']);
  }
  gotoDetail72(){
    this.router.navigate(['detail72']);
  }
  gotoDetail73(){
    this.router.navigate(['detail73']);
  }
  gotoDetail74(){
    this.router.navigate(['detail74']);
  }
  gotoDetail75(){
    this.router.navigate(['detail75']);
  }
  gotoDetail76(){
    this.router.navigate(['detail76']);
  }
  gotoDetail77(){
    this.router.navigate(['detail77']);
  }
  gotoDetail78(){
    this.router.navigate(['detail78']);
  }
  gotoDetail79(){
    this.router.navigate(['detail79']);
  }
  gotoDetail80(){
    this.router.navigate(['detail80']);
  }
  gotoDetail81(){
    this.router.navigate(['detail81']);
  }
  gotoDetail96(){
    this.router.navigate(['detail96']);
  }
  gotoDetail98(){
    this.router.navigate(['detail98']);
  }
  gotoDetail101(){
    this.router.navigate(['detail101']);
  }
  gotoDetail106(){
    this.router.navigate(['detail106']);
  }
  gotoDetail107(){
    this.router.navigate(['detail107']);
  }
  gotoDetail110(){
    this.router.navigate(['detail110']);
  }
  gotoDetail114(){
    this.router.navigate(['detail114']);
  }
  gotoDetail115(){
    this.router.navigate(['detail115']);
  }
  gotoDetail120(){
    this.router.navigate(['detail120']);
  }
  gotoDetail121(){
    this.router.navigate(['detail121']);
  }
  gotoDetail126(){
    this.router.navigate(['detail126']);
  }
  gotoDetail137(){
    this.router.navigate(['detail137']);
  }
  gotoDetail139(){
    this.router.navigate(['detail139']);
  }
  gotoDetail146(){
    this.router.navigate(['detail146']);
  }
  gotoDetail149(){
    this.router.navigate(['detail149']);
  }
  gotoDetail150(){
    this.router.navigate(['detail150']);
  }
  gotoDetail152(){
    this.router.navigate(['detail152']);
  }
  gotoDetail155(){
    this.router.navigate(['detail155']);
  }
  gotoDetail156(){
    this.router.navigate(['detail156']);
  }
  gotoDetail157(){
    this.router.navigate(['detail157']);
  }
  gotoDetail159(){
    this.router.navigate(['detail159']);
  }
  gotoDetail161(){
    this.router.navigate(['detail161']);
  }
  gotoDetail162(){
    this.router.navigate(['detail162']);
  }
  gotoDetail168(){
    this.router.navigate(['detail168']);
  }
  gotoDetail173(){
    this.router.navigate(['detail173']);
  }
  gotoDetail183(){
  this.router.navigate(['detail183']);
  }
  gotoDetail187(){
    this.router.navigate(['detail187']);
  }
  gotoDetail188(){
    this.router.navigate(['detail188']);
  }
  gotoDetail190(){
    this.router.navigate(['detail190']);
  }
  gotoDetail191(){
    this.router.navigate(['detail191']);
  }
  gotoDetail192(){
    this.router.navigate(['detail192']);
  }
  gotoDetail193(){
    this.router.navigate(['detail193']);
  }
  gotoDetail194(){
    this.router.navigate(['detail194']);
  }
  gotoDetail196(){
    this.router.navigate(['detail196']);
  }
  gotoDetail220(){
    this.router.navigate(['detail220']);
  }
  topFunction() {
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
  }, 500);
}

  



}



// WEBPACK FOOTER //
// ./src/app/news/new6.component.ts